import React from 'react';
import ModalWrapper from 'Common/Components/ModalWrapper';
import { ModalContent, Content } from './styled';

const FlexModal = ({ children, fullHeigth }) => (
  <ModalWrapper>
    <ModalContent fullHeigth={ fullHeigth }>
      <Content>
        {children}
      </Content>
    </ModalContent>
  </ModalWrapper>
);

export default FlexModal;
